import { Link } from 'react-router-dom';
import ImageComponent from '@components/ui/ImageComponent';

const Footer = () => {
  // Configuration object to show/hide footer sections and individual links
  const footerConfig = {
    showLogo: true,
    showSocialMedia: true,
    showQuickLinks: true,
    showPrograms: true,
    showContact: true,
    showCopyright: true,
    
    // Individual link controls
    quickLinks: {
      home: true,
      about: true,
      workshops: false,  // Hidden for now
      pricing: false,    // Hidden for now
      contact: true,
      privacy: true,
      terms: true
    },
    
    programs: {
      mpower: true,
      soranAcademy: true,
      homeschooling: false, //hidden for now
      allPrograms: false,  // Hidden for now
      parentPortal: false, 
    }
  };

  return (
    <footer className="bg-secondary-dark text-white py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          {footerConfig.showLogo && (
            <div className="col-span-1 md:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <ImageComponent 
                  src="/assets/logos/soranlogo.jpg" 
                  alt="Soran Foundation logo" 
                  category="logos" 
                  className="h-12 w-auto"
                  decoding="async"
                  fetchPriority="low"
                  sizes="(min-width: 768px) 192px, 144px"
                />
              </Link>
              <p className="text-secondary-light text-sm mb-4">
                Empowering children with special needs through inclusive education and support.
              </p>
              {footerConfig.showSocialMedia && (
                <div className="flex space-x-4">
                  <a href="#" className="text-white hover:text-accent" aria-label="Facebook">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                    </svg>
                  </a>
                  <a href="#" className="text-white hover:text-accent" aria-label="Twitter">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </a>
                  <a href="#" className="text-white hover:text-accent" aria-label="Instagram">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                    </svg>
                  </a>
                </div>
              )}
            </div>
          )}
          
          {/* Quick Links */}
          {footerConfig.showQuickLinks && (
            <div>
              <h3 className="text-white font-medium mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {footerConfig.quickLinks.home && (
                  <li>
                    <Link to="/" className="text-secondary-light hover:text-accent text-sm">
                      Home
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.about && (
                  <li>
                    <Link to="/about" className="text-secondary-light hover:text-accent text-sm">
                      About Us
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.workshops && (
                  <li>
                    <Link to="/workshops" className="text-secondary-light hover:text-accent text-sm">
                      Workshops
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.pricing && (
                  <li>
                    <Link to="/pricing" className="text-secondary-light hover:text-accent text-sm">
                      Pricing
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.contact && (
                  <li>
                    <Link to="/contact" className="text-secondary-light hover:text-accent text-sm">
                      Contact Us
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.privacy && (
                  <li>
                    <Link to="/privacy" className="text-secondary-light hover:text-accent text-sm">
                      Privacy Policy
                    </Link>
                  </li>
                )}
                {footerConfig.quickLinks.terms && (
                  <li>
                    <Link to="/terms" className="text-secondary-light hover:text-accent text-sm">
                      Terms of Service
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
          
          {/* Programs */}
          {footerConfig.showPrograms && (
            <div>
              <h3 className="text-white font-medium mb-4">Programs</h3>
              <ul className="space-y-2">
                {footerConfig.programs.mpower && (
                  <li>
                    <Link to="/mpower" className="text-secondary-light hover:text-accent text-sm">
                      MPOWER @ Home
                    </Link>
                  </li>
                )}
                {footerConfig.programs.soranAcademy && (
                  <li>
                    <Link to="/soran-academy" className="text-secondary-light hover:text-accent text-sm">
                      SORAN Academy
                    </Link>
                  </li>
                )}
                {footerConfig.programs.homeschooling && (
                  <li>
                    <Link to="/homeschooling" className="text-secondary-light hover:text-accent text-sm">
                      Homeschooling
                    </Link>
                  </li>
                )}
                {footerConfig.programs.allPrograms && (
                  <li>
                    <Link to="/programs" className="text-secondary-light hover:text-accent text-sm">
                      All Programs
                    </Link> 
                  </li>
                )}
                {footerConfig.programs.parentPortal && (
                  <li>
                    <Link to="/parent-portal" className="text-secondary-light hover:text-accent text-sm">
                      Parent Portal
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
          
          {/* Contact */}
          {footerConfig.showContact && (
            <div>
              <h3 className="text-white font-medium mb-4">Contact Us</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-accent mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="text-secondary-light text-sm">
                    Vasant Vihar Phase 2, Dehradun, Uttarakhand, India
                  </span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-accent mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:tech@soranacademy.com" className="text-secondary-light hover:text-accent text-sm transition-colors">
                    tech@soranacademy.com
                  </a>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-accent mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a href="tel:+918307072211" className="text-secondary-light hover:text-accent text-sm transition-colors">
                    +91 8307072211
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
        
        {footerConfig.showCopyright && (
          <div className="border-t border-secondary pt-6 mt-8 text-center">
            <p className="text-secondary-light text-sm">
              &copy; {new Date().getFullYear()} Soran Kids Foundation. All rights reserved.
            </p>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;